import { useQuery } from "@tanstack/react-query";

import { get } from "./client";
import type { ApiResponse } from "./deals";
import { isApiError } from "./errors";
import { queryKeys } from "./queryKeys";

export interface DependencyItemsQueryParams {
  status?: string;
  /** Read from this immutable Deal Data Version snapshot instead of live rows. */
  dealDataVersionId?: number;
  skip?: number;
  take?: number;
}

export interface CurrentDependencyItemDto {
  dependencyItemId: number;
  sourceDocumentVersionId: number;
  documentId: number;
  sourceDepId?: string | null;
  sourceWorksheet?: string | null;
  sourceRowNumber: number;
  workstream?: string | null;
  dependentWorkstream?: string | null;
  subFunction?: string | null;
  level?: string | null;
  description?: string | null;
  strength?: string | null;
  dealPhase?: string | null;
  day1Critical?: boolean | null;
  status?: string | null;
  normalizedStatus?: string | null;
  inferredStatus?: string | null;
  riskReasonCodes?: string[] | null;
  primaryReasonCode?: string | null;
  riskMetrics?: {
    insufficientDataReasons?: string[] | null;
  } | null;
  dateRaised?: string | null;
  dateDue?: string | null;
  last_updated_at?: string | null;
  lastUpdatedAt?: string | null;
  owner?: string | null;
  confidentiality?: boolean | null;
  comments?: string | null;
}

export function getDependencyItems(params?: DependencyItemsQueryParams) {
  return get<ApiResponse<CurrentDependencyItemDto[]>>("/dependencies/items", { params });
}

export function useGetDependencyItems(params?: DependencyItemsQueryParams, enabled = true) {
  return useQuery({
    queryKey: queryKeys.api.dependencyItems(params),
    enabled:
      enabled && (params?.dealDataVersionId == null || params.dealDataVersionId > 0),
    queryFn: async () => {
      try {
        const response = await getDependencyItems(params);
        return response.data ?? [];
      } catch (err) {
        if (isApiError(err) && err.status === 404) {
          return [];
        }
        throw err;
      }
    },
  });
}
